import { createSelector } from "../../../utils/createSelector.es.js";
const unstable_gridHeaderFilteringStateSelector = (state) => state.headerFiltering;
const unstable_gridHeaderFilteringEditFieldSelector = createSelector(unstable_gridHeaderFilteringStateSelector, (headerFilteringState) => headerFilteringState.editing);
const unstable_gridHeaderFilteringMenuSelector = createSelector(unstable_gridHeaderFilteringStateSelector, (headerFilteringState) => headerFilteringState.menuOpen);
export {
  unstable_gridHeaderFilteringEditFieldSelector,
  unstable_gridHeaderFilteringMenuSelector,
  unstable_gridHeaderFilteringStateSelector
};
//# sourceMappingURL=gridHeaderFilteringSelectors.es.js.map
